(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kzk-base"] && !Shopify.designMode) return;
  try {
    /* Links typed into rich text (/pages/…) stay as written; in a second language they need the
     locale root (Shopify.routes.root, e.g. /en/). Links the sections render already carry it. */
  const kzkLocalizeLinks = (root) => {
    const base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '';
    if (!base || base === '/') return;
    const prefix = base.replace(/\/$/, '');
    for (const link of root.querySelectorAll('.kzk a[href^="/"]')) {
      const href = link.getAttribute('href') || '';
      if (href.startsWith('//') || href.startsWith(base) || href === prefix) continue;
      link.setAttribute('href', prefix + href);
    }
  };
  kzkLocalizeLinks(document);
  document.addEventListener('shopify:section:load', (event) => {
    kzkLocalizeLinks(event.target instanceof Element ? event.target : document);
  });
  } catch(e) { console.error(e); }
})();

})();
